// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {Component, PropTypes} from 'react';
import DatePicker from 'react-datepicker';
import {getDateFormat} from '../../../shared/services/get-date-format';
import {getUser} from '../../../shared/services/get-user';
import moment from 'moment';
import {translate} from '../../../shared/services/translation-service';

function makeLocal(date, nullAllowed) {

    let localDate;

    /* eslint-disable no-nested-ternary, no-undefined */

    localDate = date ? date.local() : nullAllowed ? null : undefined;

    /* eslint-enable no-nested-ternary, no-undefined */

    if (localDate) {

        localDate = localDate.subtract(localDate.utcOffset(), 'minutes');

    } else {

        localDate = date;

    }

    return localDate;

}

class WarrantyDatePicker extends Component {

    state = {
        localEndDate: makeLocal(this.props.endDate),
        localMaxDate: makeLocal(this.props.maxDate),
        localMinDate: makeLocal(this.props.minDate),
        localStartDate: makeLocal(this.props.startDate),
        localValue: makeLocal(this.props.selected, true)
    };

    componentWillReceiveProps = nextProps => {

        this.setState({
            localEndDate: makeLocal(nextProps.endDate),
            localMaxDate: makeLocal(nextProps.maxDate),
            localMinDate: makeLocal(nextProps.minDate),
            localStartDate: makeLocal(nextProps.startDate),
            localValue: makeLocal(nextProps.selected, true)
        });

    };

    handleDateChange = date => {

        if (date && date.utcOffset()) {

            date.add(date.utcOffset(), 'minutes').utc();

        }

        this.props.onChange(date);

    };

    /* eslint-disable complexity */

    handleOnBlur = event => {

        const date = moment(event.target.value, this.datepicker.props.dateFormat, true).utc();

        const dateNotValid = !date.isValid() || (this.props.minDate && date.isBefore(this.props.minDate)) || (this.props.maxDate && date.isAfter(this.props.maxDate));

        if (dateNotValid) {

            this.datepicker.setState({inputValue: this.state.localValue});

        }

        this.props.onBlur(event);

    };

    /* eslint-enable complexity */

    render() {

        const user = getUser();

        return (
            <DatePicker
                className={this.props.className}
                dateFormat={getDateFormat(user.settings.general.dateFormat.key)}
                endDate={this.state.localEndDate}
                locale={user.getCkcValue()}
                maxDate={this.state.localMaxDate}
                minDate={this.state.localMinDate}
                onBlur={this.handleOnBlur}
                onChange={this.handleDateChange}
                placeholderText={user.getDateFormatValue()}
                ref={
                    datepicker => {

                        this.datepicker = datepicker;

                    }
                }
                selected={this.state.localValue}
                showYearDropdown={true}
                startDate={this.state.localStartDate}
                todayButton={translate('TODAY')}
            />
        );

    }

}

WarrantyDatePicker.displayName = 'DatePicker';
WarrantyDatePicker.propTypes = {
    className: PropTypes.string,
    endDate: PropTypes.object,
    maxDate: PropTypes.object,
    minDate: PropTypes.object,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    selected: PropTypes.object,
    showYearDropdown: PropTypes.bool,
    startDate: PropTypes.object,
    todayButton: PropTypes.string
};
WarrantyDatePicker.defaultProps = {
    minDate: moment().subtract(10, 'years'),
    onBlur: () => ({})
};

export default WarrantyDatePicker;



// WEBPACK FOOTER //
// ./src/shared/components/warranty-date-picker/index.js